import styled from "@emotion/styled";
import { AnimatePresence, motion } from "framer-motion";
import { FC, useState } from "react";
import { useApp } from "../AppProvider";
import { XMarkIcon } from "@heroicons/react/24/solid";

const Backdrop = styled(motion.div)(() => ({
  position: "fixed",
  willChange: "transform",
  top: 0,
  left: 0,
  width: "100%",
  height: "100vh",
  backgroundColor: "rgba(0, 0, 0, 0.8)",
  zIndex: 100,
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
}));

const VideoContent = styled(motion.iframe)(() => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  willChange: "transform",
  height: 600,
  width: "clamp(300px, 80%, 1200px)",
  "@media (max-width: 768px)": {
    height: "auto",
    width: "100%",
  },
}));

const CloseButton = styled("button")(() => ({
  position: "absolute",
  top: "1rem",
  right: "1rem",
  border: "none",
  backgroundColor: "transparent",
  outline: "none",
  cursor: "pointer",
  padding: "1rem",
  "& svg": {
    width: 24,
    height: 24,
    fill: "#fff",
  },
}));

export const VideoFrame: FC = () => {
  const app = useApp();
  const [ready, setReady] = useState(false);

  return (
    <AnimatePresence>
      {app.modalVideoUrl !== null && (
        <Backdrop
          onClick={() => {
            app.setModalVideoUrl(null);
          }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <VideoContent
            onLoadCapture={() => setReady(true)}
            initial={{ x: "-200%", y: "-50%" }}
            animate={{ x: ready ? "-50%" : "-200%", y: "-50%" }}
            exit={{ x: "-200%", y: "-50%" }}
            transition={{ type: "spring", stiffness: 100, damping: 20 }}
            src={app.modalVideoUrl}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
          <CloseButton
            type={"button"}
            onClick={() => app.setModalVideoUrl(null)}
          >
            <XMarkIcon />
          </CloseButton>
        </Backdrop>
      )}
    </AnimatePresence>
  );
};
